import {Team} from "../../api/Model";
import {Stack, Typography} from "@mui/material";
import React from "react";

export function TeamPathPane({teamPath}: {
    teamPath: Team[] | undefined,
}) {
    let teamName: string;
    let parentPath: string;
    if (teamPath) {
        teamName = teamPath[teamPath.length - 1].name;
        parentPath = teamPath
            .slice(0, teamPath.length - 1)
            .map(team => team.name)
            .join(' > ');
    } else {
        teamName = 'Team';
        parentPath = '';
    }

    return (
        <Stack>
            {parentPath && (
                <Typography variant="body2" sx={{color: "grey.400"}}>{parentPath}</Typography>
            )}
            <Typography variant="body1">{teamName}</Typography>
        </Stack>
    );
}